import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useTranslations } from 'next-intl'

interface FormSuccessStepProps {
  image: React.ReactNode
}

/**
 *
 * @description A screen for when the form is successfully submitted.
 * @param {FormSuccessStepProps} FormSuccessStepProps
 *
 */
const FormSuccessStep = ({ image }: FormSuccessStepProps) => {
  const t = useTranslations('success')
  const { breakpoints } = useTheme()

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '16px',
      height: '100%',
    },
    h4: {
      marginTop: '40px',
      [breakpoints.up('md')]: {
        marginTop: '20px',
      },
    },
  }

  return (
    <Box sx={styles.container}>
      <Box
        sx={{
          width: '100%',
          maxWidth: '120px',
          height: '100%',
          maxHeight: '120px',
        }}
      >
        {image}
      </Box>
      <Typography variant="h4" sx={styles.h4}>
        {t('title')}
      </Typography>
      <Typography
        variant="h6"
        dangerouslySetInnerHTML={{ __html: t('subtitle') }}
      />
    </Box>
  )
}

export default FormSuccessStep
